import React from 'react';
import ReactDOM from 'react-dom/client';

import { LoginContextProvider } from './context/loginContext';
import { LoginContextSUProvider } from './context/loginContextSU';
import { DisplayModeContextProvider } from './context/displayModeContext';
import { NavBarStateContextProvider } from './context/navBarStateContext';

import App from './App';
import "./styles/style.scss";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LoginContextProvider>
      <LoginContextSUProvider>
        <DisplayModeContextProvider>
          <NavBarStateContextProvider>
            <App />
          </NavBarStateContextProvider>
        </DisplayModeContextProvider>
      </LoginContextSUProvider>
    </LoginContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
